import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./FloatingInput.css";
import ToastPopup from "../Toast/toastPopup";

const FloatingInput = ({ showModal, handleCancel, handleConfirm, title, placeholder }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [input, setInput] = useState("");

  useEffect(() => {
    if (showModal) {
      setVisible(true);
    }
  }, [showModal]);

  const handleChange = (event) => {
    setInput(event.target.value.trimStart());
  };

  const handleCloseWithTransition = (callback) => {
    setVisible(false);
    setInput("")
    setTimeout(() => {
      if(callback){
        callback();
      }
    }, 300);
  };

  if (!showModal && !visible) return null;

  return (
    <div className="fi-box">
      <div className={`modal-content-del reject ${visible ? "modal-open" : "modal-close"} fi-cont-box`}>
        <div className="fi-title">{t(title)} </div>
        <div className="">
          <input type="text" className="fi-input" placeholder={t(placeholder)} value={input} onChange={handleChange} />
        </div>
        <div className="modal-footer-del reject">
          <button className="modal-cancel-button speciality-cancel" onClick={() => handleCloseWithTransition(handleCancel)}>
            {t("cancel")}
          </button>
          <button className="modal-confirm-button speciality-save" onClick={() => handleCloseWithTransition((handleConfirm(input)))}>
            {t("create")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FloatingInput;
